import {
  PersonaTemplateRoute_default
} from "./chunk-X5QGUNZV.js";
import {
  PersonaTemplateItemModel,
  PersonaTemplateModel
} from "./chunk-HVOSBUR3.js";

// src/PersonaTemplate/PersonaTemplate.ts
var AesirxPersonaTemplateApiService = class {
  constructor() {
    this.route = null;
    this.route = new PersonaTemplateRoute_default();
  }
  /**
   * Get litmit items of Personas Template
   * @param page (default: 1)
   * @param limit (default: 20)
   * @returns Array of PersonaTemplateModel
   *  */
  async getPersonaTemplates(page = 1, limit = 20, returnAsJSON = true) {
    try {
      const data = await this.route.getPersonaTemplatesRequest(page, limit);
      let results = null;
      let pagination = null;
      if (data) {
        results = new PersonaTemplateModel(data);
        pagination = results.getPagination();
      }
      if (results && returnAsJSON) {
        results = results.toJSON();
      }
      return {
        list: results,
        pagination
      };
    } catch (error) {
      return null;
    }
  }
  /**
   * Call this function once you need the detail inforamtion of a Persona Item by passing a personaTemplateId
   * @param personaTemplateId (default: null)
   * @returns PersonaTemplateItemModel (available) | null (not found or errors)
   *  */
  async getPersonaTemplate(personaTemplateId = 0, returnAsJSON = true) {
    try {
      if (personaTemplateId === 0)
        return null;
      const data = await this.route.getPersonaTemplateRequest(personaTemplateId);
      let item = null;
      if (data) {
        item = new PersonaTemplateItemModel(data);
      }
      if (item && returnAsJSON) {
        item = item.toJSON();
      }
      return item;
    } catch (error) {
      return error;
    }
  }
  render() {
    return {};
  }
};

export {
  AesirxPersonaTemplateApiService
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
